<template>
  <div>
    <a-page-header>
        <template v-slot:title >
        <a-space align="center">
            <div
              class="ant-descriptions-title"
              style="font-size: 20px; margin-bottom: 0px"
            >
              房源管理
            </div>
          </a-space>
      
      </template>
      <!-- actions -->
      <template v-slot:extra>
        <!-- 固钉 -->
        <a-affix :offset-top="10">
          <a-button-group style="margin-right: 2px">
            <a-button @click="back">返回</a-button>
            <a-button>保存</a-button>
            <a-button type="primary">提交</a-button>
          </a-button-group>
        </a-affix>
      </template>
      <!-- <div v-if="spinning">
        <div :key="index" v-for="index in 10">
          <a-card style="margin-bottom: 6px">
            <a-skeleton active />
          </a-card>
        </div>
      </div> -->

      <ResourceInfo></ResourceInfo>

      <!-- 回到最高点 -->
      <a-back-top style="margin-right: -100px" />
    </a-page-header>
  </div>
</template>

<script>
import ResourceInfo from "./resourceInfo/ResourceInfo";
export default {
  components: {
    ResourceInfo,
  },

  data() {
    return {};
  },
  methods: {
    back() {
      this.$emit('changeToLeader')
    },
  },
};
</script>

<style lang="less" scoped>
</style>